import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import classnames from "classnames";
import showdown from "showdown";

export default () => {
  const currentActivity = useSelector((state) => state.activity);
  const converter = new showdown.Converter();
  const subtitle = converter.makeHtml(
    currentActivity.websiteData.callToActionVideo.subtitle
  );
  return (
    currentActivity &&
    (currentActivity.name || currentActivity.shortDescription) && (
      <div
        id="about"
        className="gradiant-background pwg-section about-section section"
      >
        <div className="container tab-fix">
          <div className="section-head text-center">
            <div className="row">
              <div className="col-md-8 col-md-offset-2">
                <h2 className="heading heading-light">
                  {`${
                    currentActivity &&
                    currentActivity.websiteData &&
                    currentActivity.websiteData.callToActionVideo &&
                    currentActivity.websiteData.callToActionVideo.title
                      ? currentActivity.websiteData.callToActionVideo.title
                      : "About the event"
                  }`}
                </h2>
                {currentActivity.websiteData.callToActionVideo.subtitle && (
                  <p
                    className="h4 heading-light"
                    dangerouslySetInnerHTML={{ __html: subtitle }}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="rowtab-center mobile-center">
            <div className="col-md-6">
              <div className="txt-entry whitetxt textjustify">
                <p className="textjustify heading-light">
                  {`${
                    currentActivity && currentActivity.shortDescription
                      ? currentActivity.shortDescription
                      : "Complete the event description"
                  }`}{" "}
                </p>
              </div>
              <div className="centerBox" style={{ marginBottom: "30px" }}>
                <a
                  className="button solid-btn sb-h"
                  href={`https://applyforms.lafactory.co/${currentActivity._id}/`}
                  target="_blank"
                  rel="noopener noreferrer"
                  // style={{
                  //   backgroundColor: "#313e48",
                  // }}
                >
                  S'INSCRIRE
                </a>
              </div>
            </div>
            <div className="col-md-6">
              <VideoPlayerPopup currentActivity={currentActivity} />
            </div>
          </div>
        </div>
      </div>
    )
  );
};

const VideoPlayerPopup = ({ currentActivity }) => {
  useEffect(() => {
    const $video_play = window.$(".video-play");
    if ($video_play.length > 0) {
      $video_play.magnificPopup({
        type: "iframe",
        removalDelay: 160,
        preloader: true,
        fixedContentPos: false,
      });
    }
  });

  return (
    <div className="video wow fadeInRight" data-wow-duration=".5s">
      {currentActivity &&
        currentActivity.websiteData &&
        currentActivity.websiteData.callToActionVideo &&
        currentActivity.websiteData.callToActionVideo.data &&
        currentActivity.websiteData.callToActionVideo.data.bgImage && (
          <img
            src={currentActivity.websiteData.callToActionVideo.data.bgImage}
            alt="about-video"
          />
        )}
      {currentActivity &&
        currentActivity.websiteData &&
        currentActivity.websiteData.callToActionVideo &&
        currentActivity.websiteData.callToActionVideo.data &&
        currentActivity.websiteData.callToActionVideo.data.link && (
          <>
            <div
              className="video-overlay"
              style={{
                backgroundImage:
                  "linear-gradient(293deg, #638b1854 0%, #638b187a 100%)",
              }}
            />
            <a
              href={currentActivity.websiteData.callToActionVideo.data.link.replace(
                "youtu.be/",
                "youtube.com/watch?v="
              )}
              className="video-play"
            >
              <i className="fa fa-play" />
            </a>
          </>
        )}
    </div>
  );
};
